import React from 'react'

import { DATE_TIME_FORMAT, formatDateTime } from '@app/common/helpers/DateTime/DateTime'
import { useIntl } from '@app/intl/Intl'
import { bemJoin } from '@app/lib/bem'
import { IconBadge } from '@app/lib/display/IconBadge/IconBadge'
import { Timeline } from '@app/lib/layout/Timeline/Timeline'
import { Text } from '@app/lib/typography/Text/Text'
import { EVENT_SETTINGS } from '@app/modules/CourtCases/helpers/eventSettings'
import { CourtCaseEventFragment } from '@app/queries/CourtCases/CourtCase.queries'

import './styles.scss'

export const CourtCaseTimeline = ({
  timelineItems
}: {
  timelineItems: CourtCaseEventFragment[]
}) => {
  const { formatMessage } = useIntl()
  const b = bemJoin('court-case-timeline')

  return (
    <div className={b()}>
      <Text size={'ml'} weight={'bold'}>
        {formatMessage({ id: 'CourtCases.Timeline.Title' })}
      </Text>
      <Timeline>
        {timelineItems.map((item, index) => {
          const { iconColor, icon: IconComponent } = EVENT_SETTINGS[item.eventType]
          return (
            <Timeline.Item key={index}>
              <Timeline.Item.Icon>
                <IconBadge size='smd' color={iconColor}>
                  <IconComponent />
                </IconBadge>
              </Timeline.Item.Icon>
              <Timeline.Item.Time>
                {formatDateTime(item.date || item.createdAt, DATE_TIME_FORMAT.DATE_FULL)}
              </Timeline.Item.Time>
              <Timeline.Item.Entry>{item.title}</Timeline.Item.Entry>
            </Timeline.Item>
          )
        })}
      </Timeline>
    </div>
  )
}
